import { render, staticRenderFns } from "./training-status.vue?vue&type=template&id=c871bcfe&"
import script from "./training-status.vue?vue&type=script&lang=js&"
export * from "./training-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports